import React, { useEffect, useState } from "react";
import Input from "../../components/common/Input";
import { staffAPI } from "../../services/api";
import { academicAPI } from "../../services/api";
import de from "date-fns/locale/de";

const classSections = {
    "Day Care": ["Rose", "Lotus"],
    "Play Group": ["Rose", "Lotus", "Jasmine"],
    "Nursery": ["Rose", "Lotus", "Jasmine"],
    "PP-1": ["Tulip", "Lily"],
    "PP-2": ["Tulip", "Lily"],
    "1st Class": ["Rose", "Lotus", "Jasmine", "Tulip"],
    "2nd Class": ["Rose", "Lotus", "Jasmine", "Tulip"],
    "3rd Class": ["Rose", "Lotus", "Jasmine", "Tulip"],
    "4th Class": ["Sunflower", "Lily", "Orchid"],
    "5th Class": ["Sunflower", "Lily", "Orchid"],
    "6th Class": ["Daisy", "Rose", "Lotus"],
    "7th Class": ["Daisy", "Rose", "Lotus"],
    "8th Class": ["Orchid", "Sunflower", "Tulip"],
    "9th Class": ["Orchid", "Sunflower", "Tulip"],
    "10th Class": ["Orchid", "Sunflower", "Tulip", "Jasmine"],
};

const permissionModules = {
    "Fees Management": [
        "Update Student Fee",
        "Collect Fee",
        "Reports",
        "Fee Discount",
        "Fee Structure",
        "Fee Reminder",
    ],
    Examination: [
        "Marks Entry",
        "Result View",
        "Subject Wise Marks Entry",
        "Hall Tickets",
        "Progress Report",
    ],
    Attendance: [
        "Student Attendance",
        "Staff Attendance",
        "Biometric Attendance",
    ],
    Admissions: [
        "New Admission",
        "Student Promotion",
        "Transfer Certificate",
        "Student Search",
    ],
    Library: [
        "Issue Book",
        "Return Book",
        "Book Inventory",
        "Fine Collection",
    ],
};

const ClassSubjectIncharge = () => {
    const [loading, setLoading] = useState(true);
    const [staff, setStaff] = useState("");
    const [selectedClasses, setSelectedClasses] = useState([]);
    const [selectedSections, setSelectedSections] = useState({});
    const [selectedPermissions, setSelectedPermissions] = useState({});
    const [classes, setClasses] = useState([]);

    const [classSections, setClassSections] = useState({});

    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [staffList, setstaffList] = useState([]);
    const [selectedStaffList, setSelectedStaffList] = useState("");
    const [subjects, setSubjects] = useState([]);
    const [selectedSubjects, setSelectedSubjects] = useState("");



    useEffect(() => {
        getClasses();
        getStaffList();
        getSubjects();
        getDepartmentsfList();
    }, []);

    const getSubjects = async () => {
        setLoading(true);

        try {
            const res = await academicAPI.subjects();
            console.log(res.data); // 👈 Check this
            const subData = res.data?.results || [];
            setSubjects(subData);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // department filter start
    const getDepartmentsfList = async () => {
        setLoading(true);
        try {
            const res = await staffAPI.departments();
            const data = res.data?.results || [];
            setDepartments(data);
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    }
    // department filter end

    const getStaffList = async () => {
        setLoading(true);
        try {
            const res = await staffAPI.list();
            const data = res.data?.results || [];
            setstaffList(data);
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    }

    const getClasses = async () => {
        setLoading(true);
        try {
            const response = await staffAPI.getClasses();
            const data = response.data?.results || [];
            setClasses(data);
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    };

    const toggleClass = async (classData) => {
        const className = classData.name;
        const classId = classData.id;

        if (selectedClasses.includes(className)) {
            setSelectedClasses(prev =>
                prev.filter(item => item !== className)
            );
            setClassSections(prev => {
                const copy = { ...prev };
                delete copy[className];
                return copy;
            });
            return;
        }
        setSelectedClasses(prev => [
            ...prev,
            className
        ]);
        try {
            const response = await staffAPI.getSections(
                classData.numeric_value
            );
            const sections =
                response.data?.results ||
                response.data ||
                [];
            // FILTER ONLY CURRENT CLASS SECTIONS
            const filteredSections = sections.filter(
                section =>
                    section.class_obj === classId
            );
            console.log(
                "Filtered Sections:",
                filteredSections
            );

            setClassSections(prev => ({
                ...prev,
                [className]: filteredSections
            }));
        } catch (error) {
            console.log(error);
        }
    };

    const toggleSection = (className, sectionName) => {
        setSelectedSections(prev => {
            const current =
                prev[className] || [];
            return {
                ...prev,
                [className]:
                    current.includes(sectionName)
                        ? current.filter(
                            item => item !== sectionName
                        )
                        : [
                            ...current,
                            sectionName
                        ]
            };
        });
    };


    const togglePermission = (module, permission) => {
        setSelectedPermissions((prev) => {
            const current = prev[module] || [];
            return {
                ...prev,
                [module]: current.includes(permission)
                    ? current.filter((p) => p !== permission)
                    : [...current, permission],
            };
        });
    };

    const toggleAllPermissions = (module, permissions) => {
        setSelectedPermissions((prev) => {
            const current = prev[module] || [];
            const allSelected = permissions.every((p) => current.includes(p));
            return {
                ...prev,
                [module]: allSelected ? [] : [...permissions],
            };
        });
    };

  const handleSubmitSub = () => {
    // Validate Staff
    if (!selectedStaffList) {
        alert("Please select staff");
        return;
    }

    // Validate Subject
    if (!selectedSubjects) {
        alert("Please select subject");
        return;
    }

    // Validate Classes
    if (selectedClasses.length === 0) {
        alert("Please select at least one class");
        return;
    }


    // Validate Sections
    const hasSections = Object.values(selectedSections)
        .some(section => section.length > 0);
    if (!hasSections) {
        alert("Please select at least one section");
        return;
    }

    // Validate Permissions
    // const hasPermissions = Object.values(selectedPermissions)
    //     .some(permission => permission.length > 0);
    // if (!hasPermissions) {
    //     alert("Please select permissions");
    //     return;
    // }

    const payload = {
        staff: selectedStaffList,
        subject: selectedSubjects,
        classes: selectedClasses,
        sections: selectedSections,
        // permissions: selectedPermissions,
    };
    console.log("Payload:", payload);
    alert("Data saved successfully!");
};

    return (
        <>
            <div className="page-header">
                <div><h2>Class Subject Incharge</h2></div>
            </div>

            <div className="card shadow-sm border-0">
                <div className="card-body">
                    <div className="row">
                        {/* Dropdowns */}
                        <div className="col-md-3 col-sm-6">
                            <Input
                                label="Departments"
                                name="department"
                                elementType="select"
                                value={selectedDepartment}
                                onChange={(e) => {
                                    setSelectedDepartment(e.target.value);
                                    getDepartmentsfList(e);
                                }}
                                options={
                                    departments.map((dept) => ({
                                        value: dept.id,
                                        label: dept.name,
                                    }))
                                }
                                required
                            />
                        </div>

                        <div className="col-md-3 col-sm-6">
                            <Input
                                label="Staff Name"
                                name="staffName"
                                elementType="select"
                                value={selectedStaffList}
                                onChange={(e) => {
                                    setSelectedStaffList(e.target.value);
                                    getStaffList(e);
                                }}
                                options={staffList.map((stf) => ({
                                    value: stf.id,
                                    label: stf.full_name,
                                }))}
                                required
                            />
                        </div>

                        <div className="col-md-3 col-sm-6">
                            <Input
                                label="Curriculum"
                                name="curriculum"
                                elementType="select"
                                options={[
                                    { value: "ssc", label: "SSC" },
                                    { value: "cbse", label: "CBSC" },
                                ]}
                            />
                        </div>

                        <div className="col-md-3 col-sm-6">
                            <Input
                                label="Subjects"
                                name="name"
                                elementType="select"
                                value={selectedSubjects}
                                onChange={(e) => {
                                    setSelectedSubjects(e.target.value);
                                }}
                                // options={subjects.map((sub)=>({
                                //     value: sub.id,
                                //     label: sub.name
                                // }))}
                                options={subjects.map((sub) => ({
                                    value: sub.id,
                                    label: sub.name
                                }))}
                            />
                        </div>

                        {/* Class Chips */}
                        <div className="col-md-12 mb-4">
                            <label className="form-label fs-5 fw-semibold mb-3">
                                Select Classes
                            </label>

                            {loading ? (
                                <div className="text-muted">Loading classes...</div>
                            ) : classes.length === 0 ? (
                                <div className="text-danger">No classes found.</div>
                            ) : (
                                <div className="d-flex flex-wrap gap-2">
                                    {classes.map((className) => (

                                        <button
                                            key={className.id}
                                            type="button"
                                            className={`btn btn-sm rounded-pill px-3 ${selectedClasses.includes(className.name)
                                                ? "btn-primary"
                                                : "btn-outline-primary"
                                                }`}
                                            onClick={() => toggleClass(className)}
                                        >
                                            {className.name}
                                        </button>

                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Sections */}
                        {selectedClasses.length > 0 && (
                            <div className="col-md-12">
                                <h5 className="mb-3">Class Wise Sections</h5>

                                {selectedClasses.map((className) => (

                                    <div key={className} className="card mb-3 border">


                                        <div className="card-header bg-light d-flex justify-content-between">

                                            <strong>
                                                {className}
                                            </strong>


                                            <span className="badge bg-primary">

                                                {
                                                    selectedSections[className]?.length || 0
                                                }

                                                Selected

                                            </span>

                                        </div>



                                        <div className="card-body">

                                            <div className="d-flex flex-wrap gap-2">


                                                {
                                                    (classSections[className] || [])
                                                        .map(section => (


                                                            <button
                                                                key={section.id}
                                                                type="button"

                                                                className={`btn btn-sm rounded-pill ${selectedSections[className]?.includes(section.name)

                                                                    ? "btn-success"

                                                                    : "btn-outline-secondary"

                                                                    }`}

                                                                onClick={() => toggleSection(
                                                                    className,
                                                                    section.name
                                                                )}

                                                            >

                                                                {section.name}

                                                            </button>


                                                        ))

                                                }


                                            </div>

                                        </div>


                                    </div>


                                ))}
                            </div>
                        )}

                        {/* Permissions */}
                        <div className="col-md-12">
                            <div className="permission-section">
                                <div className="row">
                                    {Object.entries(permissionModules).map(([module, permissions]) => {
                                        const selectedCount = selectedPermissions[module]?.length || 0;
                                        const allSelected = permissions.every((p) =>
                                            (selectedPermissions[module] || []).includes(p)
                                        );

                                        return (
                                            <div className="col-md-12 mb-3" key={module}>
                                                <div className="card shadow-sm border">
                                                    <div className="card-header bg-light d-flex justify-content-between align-items-center">
                                                        <strong>{module}</strong>
                                                        <span className="badge bg-primary">
                                                            {selectedCount} Selected
                                                        </span>
                                                    </div>

                                                    <div className="card-body">
                                                        <div className="d-flex flex-wrap gap-2">
                                                            <button
                                                                type="button"
                                                                className={`btn btn-sm rounded-pill ${allSelected
                                                                    ? "btn-primary"
                                                                    : "btn-outline-primary"
                                                                    }`}
                                                                onClick={() =>
                                                                    toggleAllPermissions(module, permissions)
                                                                }
                                                            >
                                                                All
                                                            </button>

                                                            {permissions.map((permission) => (
                                                                <button
                                                                    key={permission}
                                                                    type="button"
                                                                    className={`btn btn-sm rounded-pill ${selectedPermissions[module]?.includes(permission)
                                                                        ? "btn-success"
                                                                        : "btn-outline-secondary"
                                                                        }`}
                                                                    onClick={() =>
                                                                        togglePermission(module, permission)
                                                                    }
                                                                >
                                                                    {permission}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                    <div className="col-12 mt-3">
                                        <button
                                            className="btn btn-success px-4"
                                            onClick={handleSubmitSub}
                                        >
                                            Save Permissions
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default ClassSubjectIncharge;